import './application_menu_option.css';

/*
 * Description: Application Menu Option Web Component
 * Purpose: A single navigation link for the application menu sidebar
 * Author: Nuvemx
 * Created: 2026
 * 
 * Features:
 * - Displays an icon with a label
 * - Shows or hides the matching application-page when clicked
 * - Supports an active state via the status attribute
 * 
 * Usage:
 * <application-menu-option label="Home" pageId="home-page" icon="bx-home" status="active"></application-menu-option>
 * 
 * Attributes:
 * - label: String - The label to display for this menu option
 * - pageId: String - The id of the application-page to show when clicked
 * - icon: String - The Boxicons icon class (e.g., 'bx-home')
 * - status: String - Optional CSS class applied to the link (e.g., 'active')
 * 
 */

class application_menu_option extends HTMLElement {
    connectedCallback() {
        if (this.dataset.rendered) {
            return;
        }
        const label = this.getAttribute("label");
        const pageId = this.getAttribute("pageId");
        const icon = this.getAttribute("icon");
        const status = this.getAttribute("status");
        this.innerHTML = `        
            <a href="javascript:$('.body-content').hide();$('#${pageId}').show();" class="nav_link ${status}"> <i class='bx ${icon} nav_icon'></i> <span class="nav_name">${label}</span> </a> 
            `;
        this.dataset.rendered = "true";
    }
}

export { application_menu_option };